export const yellow = {
  900: '#FF6B0A',
  800: '#FF7C12',
  700: '#FF8617',
  600: '#FF911B',
  500: '#FF991F',
  400: '#FFA841',
  300: '#FFB862',
  200: '#FFCC8F',
  100: '#FFE0BC',
  50: '#FFF3E4',
}
